export const LS_CLIENT_TYPE = 'LS_CLIENT_TYPE';
